import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-app-install-button',
  templateUrl: './app-install-button.component.html',
  styleUrls: ['./app-install-button.component.css']
})
export class AppInstallButtonComponent implements OnInit {

  isAndroid = false;
  isIOS = false;
  showButton = false;
  isMweb = false;
  isWeb = false;

  constructor(private router: Router) {}

ngOnInit(): void {
  const userAgent = navigator.userAgent || navigator.vendor;
  this.isAndroid = /android/i.test(userAgent);
  this.isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;

  const checkMweb = window.innerWidth <= 768;
  this.isWeb = !checkMweb && !this.isAndroid && !this.isIOS; 
  if (checkMweb) {
    this.isMweb = true;
  }

  // Delay showButton decision until after router event fires
  this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      const isDismissed = sessionStorage.getItem('installBannerDismissed') === 'true';
      const url = event.url;
      const isExcludedPage = event.url.includes('/rentalPayment') ||
        event.url.includes('/payments/payment_success') ||
        event.url.includes('/payments/payment_failure') ||
        event.url.includes('/payments/payment_stripe') ||
        event.url.includes('/payments/payment-pending') ||
        event.url.includes('/privacy_policy') ||
        event.url.includes('/about-us') ||
        event.url.includes('/terms_and_conditions') ||
        event.url.includes('/contact-us') ||
        event.url.includes('/faq') ||
        event.url.includes('/refund_policy') ||
        event.url.includes('/content_redressal_mechanism') ||
        event.url.includes('/app-plans');

        const isPlansPage = event.url.includes('/plans');
        const isMetaPage = event.url.includes('/meta-pixel-page')
        const isAndroidBrowserParam = url.includes('browser=android');
    // - Mweb → show everywhere except excluded pages
    // - Web  → show ONLY on /plans
    if (this.isMweb) {
        this.showButton = !isDismissed && !isExcludedPage && (!isPlansPage || !isAndroidBrowserParam);
    } else if (this.isWeb) {
       this.showButton = !isDismissed && (isPlansPage || isMetaPage);
    } else {
      this.showButton = false;
    }
    }
  });
}

  closeBanner() {
    this.showButton = false;
    sessionStorage.setItem('installBannerDismissed', 'true');
  }

}
